import { useEffect, useState } from "react";

/**
 * ═══════════════════════════════════════════════════════════════════
 * ¿Estamos en una pantalla angosta? (Anahí, 29-ago).
 *
 * Nace de las tablas: ocho columnas no caben en 390 px, así que en un
 * teléfono cada fila se pinta como TARJETA y desde `md` vuelve la tabla.
 *
 * ── Por qué un hook y no `hidden md:block` ───────────────────────────
 * Con clases habría que pintar los DOS árboles y esconder uno. Eso
 * duplica el DOM —el doble de nodos y de trabajo en el móvil, que es el
 * aparato lento— y, peor, duplica el contenido para quien usa un lector
 * de pantalla: lee la lista dos veces sin saber que es la misma.
 *
 * Con el hook se monta UNO. `768px` es el `md` de Tailwind: el mismo
 * umbral, escrito una vez.
 *
 * En el servidor y en las pruebas (jsdom dobla `matchMedia` devolviendo
 * `false`) sale `false` y se pinta la tabla, que es la vista completa.
 * ═══════════════════════════════════════════════════════════════════
 */
const COMPACT_QUERY = "(max-width: 767px)";

export function useIsCompact(): boolean {
  const [compact, setCompact] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(COMPACT_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia(COMPACT_QUERY);
    const alCambiar = (event: MediaQueryListEvent) => setCompact(event.matches);
    // Girar el teléfono cambia el ancho: sin escuchar, la vista se queda
    // en la que tocó al montar.
    mq.addEventListener("change", alCambiar);
    setCompact(mq.matches);
    return () => mq.removeEventListener("change", alCambiar);
  }, []);

  return compact;
}
